function NotFound() {
  return (
    <div className="flex justify-center items-center text-primary w-full h-full">NOT FOUND</div>
  );
}

export default NotFound;
